let _portalRoot: HTMLElement | null = null;

export function getPortalRoot(): HTMLElement {
  if (typeof document === 'undefined') {
    return null as unknown as HTMLElement;
  }

  // Re-create if detached from DOM (browser extension, HMR, etc.)
  if (_portalRoot && !document.body.contains(_portalRoot)) {
    _portalRoot = null;
  }

  if (!_portalRoot) {
    _portalRoot = document.getElementById('wanzo-portal-root') as HTMLElement;
    if (!_portalRoot) {
      _portalRoot = document.createElement('div');
      _portalRoot.id = 'wanzo-portal-root';
      _portalRoot.setAttribute('aria-hidden', 'true');
      document.body.appendChild(_portalRoot);
    }
  }

  return _portalRoot;
}
